import React, { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import Modal from "@/components/Modal";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function ChangePasswordModal({ onClose }) {
  const [form, setForm] = useState({ current: "", next: "", confirm: "" });
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.next.length < 6) { toast.error("New password must be at least 6 characters"); return; }
    if (form.next !== form.confirm) { toast.error("Passwords do not match"); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", {
        current_password: form.current, new_password: form.next,
      });
      toast.success("Password updated");
      onClose();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setSaving(false); }
  };

  return (
    <Modal title="Change Password" onClose={onClose} testId="change-password-modal">
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="block text-xs font-bold uppercase tracking-wider mb-1.5">Current Password</label>
          <input data-testid="cp-current" required type="password" className="industrial-input"
            value={form.current} onChange={(e) => setForm({ ...form, current: e.target.value })}
            autoComplete="current-password" />
        </div>
        <div>
          <label className="block text-xs font-bold uppercase tracking-wider mb-1.5">New Password (min 6)</label>
          <input data-testid="cp-new" required type="password" minLength={6} className="industrial-input"
            value={form.next} onChange={(e) => setForm({ ...form, next: e.target.value })}
            autoComplete="new-password" />
        </div>
        <div>
          <label className="block text-xs font-bold uppercase tracking-wider mb-1.5">Confirm New Password</label>
          <input data-testid="cp-confirm" required type="password" minLength={6} className="industrial-input"
            value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })}
            autoComplete="new-password" />
        </div>
        <button data-testid="cp-submit" type="submit" disabled={saving} className="btn-primary w-full">
          {saving ? "Saving..." : (<><Lock className="w-5 h-5 mr-2" strokeWidth={3} /> Update Password</>)}
        </button>
      </form>
    </Modal>
  );
}
